import colors from './baseColors'

export default {
  buttonHighlightPrimaryBgDefault: colors.primarySolid500,
  buttonHighlightQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonHighlightPrimaryBgPressed: colors.primarySolid600,
  buttonHighlightPrimaryBgHover: colors.primarySolid600,
  buttonHighlightPrimaryBgDisabled: colors.primarySolid50,
  buttonHighlightQuaternaryLabelDefault: colors.primarySolid500,
  buttonHighlightQuaternaryIconDefault: colors.primarySolid500,
  buttonHighlightQuaternaryIconPressed: colors.primarySolid500,
  buttonHighlightQuaternaryIconHover: colors.primarySolid500,
  buttonHighlightQuaternaryIconDisabled: colors.neutralSolid400,
  buttonHighlightSecondaryBgDefault: colors.primarySolid50,
  buttonHighlightSecondaryBgPressed: colors.primarySolid100,
  buttonHighlightSecondaryBgHover: colors.primarySolid100,
  buttonHighlightSecondaryBgDisabled: colors.primarySolid50,
  buttonHighlightSecondaryLabelDefault: colors.primarySolid500,
  buttonHighlightSecondaryLabelHover: colors.primarySolid500,
  buttonHighlightSecondaryLabelPressed: colors.primarySolid500,
  buttonHighlightSecondaryLabelDisabled: colors.neutralBlackTransparent200,
  buttonHighlightSecondaryIconDefault: colors.primarySolid500,
  buttonHighlightSecondaryIconPressed: colors.primarySolid500,
  buttonHighlightSecondaryIconHover: colors.primarySolid500,
  buttonHighlightSecondaryIconDisabled: colors.neutralBlackTransparent200,
  buttonHighlightPrimaryLabelDefault: colors.neutralSolid0,
  buttonHighlightPrimaryLabelHover: colors.neutralSolid0,
  buttonHighlightPrimaryLabelPressed: colors.neutralSolid0,
  buttonHighlightPrimaryLabelDisabled: colors.neutralSolid0,
  buttonHighlightPrimaryIconDefault: colors.neutralSolid0,
  buttonHighlightPrimaryIconPressed: colors.neutralSolid0,
  buttonHighlightPrimaryIconHover: colors.neutralSolid0,
  buttonHighlightPrimaryIconDisabled: colors.neutralSolid0,
  buttonHighlightPrimaryStrokePressed: colors.primarySolid500,
  buttonHighlightSecondaryStrokePressed: colors.primarySolid500,
  buttonHighlightTerciaryLabelDefault: colors.primarySolid500,
  buttonHighlightTerciaryLabelHover: colors.primarySolid500,
  buttonHighlightTerciaryLabelPressed: colors.primarySolid500,
  buttonHighlightTerciaryLabelDisabled: colors.neutralBlackTransparent300,
  buttonHighlightTerciaryStrokePressed: colors.primarySolid500,
  buttonHighlightTerciaryBgHover: colors.primarySolid50,
  buttonHighlightTerciaryBgPressed: colors.primarySolid50,
  buttonHighlightTerciaryIconDefault: colors.primarySolid500,
  buttonHighlightTerciaryIconPressed: colors.primarySolid500,
  buttonHighlightTerciaryIconHover: colors.primarySolid500,
  buttonHighlightTerciaryIconDisabled: colors.neutralBlackTransparent300,
  buttonHighlightTerciaryStrokeDefault: colors.primarySolid200,
  buttonHighlightTerciaryStrokeHover: colors.primarySolid200,
  buttonHighlightTerciaryStrokeDisabled: colors.primarySolid100,
  tagBgDefault: colors.neutralSolid300,
  tagBgHover: colors.neutralSolid300,
  tagBgPressed: colors.neutralSolid300,
  tagBgDisabled: colors.neutralSolid300,
  tagStrokeFocus: colors.primarySolid500,
  tagLabelDefault: colors.neutralSolid900,
  tagLabelHover: colors.neutralSolid900,
  tagLabelPressed: colors.neutralSolid900,
  tagLabelDisabled: colors.neutralSolid400,
  tagIconDefault: colors.neutralSolid900,
  tagIconHover: colors.neutralSolid900,
  tagIconPressed: colors.neutralSolid900,
  tagIconDisabled: colors.neutralSolid400,
  tagBgFocus: colors.neutralSolid300,
  tagLabelFocus: colors.neutralSolid900,
  tagIconFocus: colors.neutralSolid900,
  buttonHighlightQuaternaryLabelHover: colors.primarySolid500,
  buttonHighlightQuaternaryLabelPressed: colors.primarySolid500,
  buttonHighlightQuaternaryLabelDisabled: colors.neutralSolid400,
  buttonHighlightQuaternaryStrokePressed: colors.primarySolid500,
  buttonSubtlePrimaryBgDefault: colors.secondarySolid500,
  buttonSubtlePrimaryIconDefault: colors.neutralSolid0,
  buttonSubtlePrimaryIconPressed: colors.neutralSolid0,
  buttonSubtlePrimaryIconHover: colors.neutralSolid0,
  buttonSubtlePrimaryIconDisabled: colors.neutralSolid0,
  buttonSubtlePrimaryLabelDefault: colors.neutralSolid0,
  buttonSubtlePrimaryLabelHover: colors.neutralSolid0,
  buttonSubtlePrimaryLabelPressed: colors.neutralSolid0,
  buttonSubtlePrimaryLabelDisabled: colors.neutralSolid0,
  buttonSubtlePrimaryBgHover: colors.secondarySolid400,
  buttonSubtlePrimaryBgPressed: colors.secondarySolid400,
  buttonSubtlePrimaryBgDisabled: colors.secondarySolid50,
  buttonSubtleSecondaryBgDefault: colors.secondarySolid100,
  buttonSubtleTerciaryBgHover: colors.secondarySolid50,
  buttonSubtleTerciaryBgPressed: colors.secondarySolid50,
  buttonSubtleTerciaryIconDefault: colors.secondarySolid900,
  buttonSubtleTerciaryIconPressed: colors.secondarySolid900,
  buttonSubtleTerciaryIconHover: colors.secondarySolid900,
  buttonSubtleTerciaryIconDisabled: colors.neutralSolid400,
  buttonSubtleTerciaryLabelDefault: colors.secondarySolid900,
  buttonSubtleTerciaryLabelHover: colors.secondarySolid900,
  buttonSubtleTerciaryLabelPressed: colors.secondarySolid900,
  buttonSubtleTerciaryLabelDisabled: colors.neutralSolid400,
  buttonSubtleTerciaryStrokeDefault: colors.secondarySolid200,
  buttonSubtleTerciaryStrokeHover: colors.secondarySolid200,
  buttonSubtleTerciaryStrokePressed: colors.secondarySolid400,
  buttonSubtleTerciaryStrokeDisabled: colors.secondarySolid100,
  buttonSubtleQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonSubtleQuaternaryLabelDefault: colors.secondarySolid400,
  buttonSubtleQuaternaryLabelHover: colors.secondarySolid500,
  buttonSubtleQuaternaryLabelPressed: colors.secondarySolid500,
  buttonSubtleQuaternaryLabelDisabled: colors.secondarySolid100,
  buttonSubtleQuaternaryIconDefault: colors.secondarySolid400,
  buttonSubtleQuaternaryStrokePressed: colors.secondarySolid400,
  buttonSubtleQuaternaryIconHover: colors.secondarySolid500,
  buttonSubtleQuaternaryIconPressed: colors.secondarySolid500,
  buttonSubtleQuaternaryIconDisabled: colors.secondarySolid100,
  buttonSubtleSecondaryIconDefault: colors.secondarySolid900,
  buttonSubtleSecondaryIconPressed: colors.secondarySolid900,
  buttonSubtleSecondaryIconHover: colors.secondarySolid900,
  buttonSubtleSecondaryIconDisabled: colors.neutralBlackTransparent200,
  buttonSubtleSecondaryLabelDefault: colors.secondarySolid900,
  buttonSubtleSecondaryBgHover: colors.secondarySolid200,
  buttonSubtleSecondaryStrokePressed: colors.secondarySolid300,
  buttonSubtleSecondaryLabelHover: colors.secondarySolid900,
  buttonSubtleSecondaryLabelPressed: colors.secondarySolid900,
  buttonSubtleSecondaryLabelDisabled: colors.neutralBlackTransparent200,
  buttonSubtleSecondaryBgPressed: colors.secondarySolid200,
  buttonSubtleSecondaryBgDisabled: colors.secondarySolid50,
  buttonSubtlePrimaryStrokePressed: colors.secondarySolid300,
  buttonNegativePrimaryBgDefault: colors.redSolid600,
  buttonNegativePrimaryIconDefault: colors.neutralSolid0,
  buttonNegativePrimaryIconPressed: colors.neutralSolid0,
  buttonNegativePrimaryIconHover: colors.neutralSolid0,
  buttonNegativePrimaryIconDisabled: colors.neutralSolid0,
  buttonNegativePrimaryLabelDefault: colors.neutralSolid0,
  buttonNegativePrimaryLabelHover: colors.neutralSolid0,
  buttonNegativePrimaryLabelPressed: colors.neutralSolid0,
  buttonNegativePrimaryLabelDisabled: colors.neutralSolid0,
  buttonNegativePrimaryBgHover: colors.redSolid500,
  buttonNegativePrimaryBgPressed: colors.redSolid500,
  buttonNegativePrimaryBgDisabled: colors.redSolid100,
  buttonNegativeSecondaryBgDefault: colors.redSolid50,
  buttonNegativeTerciaryBgHover: colors.redSolid50,
  buttonNegativeTerciaryBgPressed: colors.redSolid50,
  buttonNegativeTerciaryIconDefault: colors.redSolid500,
  buttonNegativeTerciaryIconPressed: colors.redSolid500,
  buttonNegativeTerciaryIconHover: colors.redSolid500,
  buttonNegativeTerciaryIconDisabled: colors.redSolid100,
  buttonNegativeTerciaryLabelDefault: colors.redSolid500,
  buttonNegativeTerciaryLabelHover: colors.redSolid500,
  buttonNegativeTerciaryLabelPressed: colors.redSolid500,
  buttonNegativeTerciaryLabelDisabled: colors.redSolid100,
  buttonNegativeTerciaryStrokeDefault: colors.redSolid500,
  buttonNegativeTerciaryStrokeHover: colors.redSolid500,
  buttonNegativeTerciaryStrokePressed: colors.redSolid500,
  buttonNegativeTerciaryStrokeDisabled: colors.redSolid100,
  buttonNegativeQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNegativeQuaternaryLabelDefault: colors.redSolid500,
  buttonNegativeQuaternaryLabelHover: colors.redSolid600,
  buttonNegativeQuaternaryLabelPressed: colors.redSolid600,
  buttonNegativeQuaternaryLabelDisabled: colors.redSolid100,
  buttonNegativeQuaternaryIconDefault: colors.redSolid500,
  buttonNegativeQuaternaryStrokePressed: colors.redSolid500,
  buttonNegativeQuaternaryIconHover: colors.redSolid600,
  buttonNegativeQuaternaryIconPressed: colors.redSolid600,
  buttonNegativeQuaternaryIconDisabled: colors.redSolid100,
  buttonNegativeSecondaryIconDefault: colors.redSolid500,
  buttonNegativeSecondaryIconPressed: colors.redSolid500,
  buttonNegativeSecondaryIconHover: colors.redSolid500,
  buttonNegativeSecondaryIconDisabled: colors.redSolid100,
  buttonNegativeSecondaryLabelDefault: colors.redSolid500,
  buttonNegativeSecondaryBgHover: colors.redSolid100,
  buttonNegativeSecondaryStrokePressed: colors.redSolid500,
  buttonNegativeSecondaryLabelHover: colors.redSolid500,
  buttonNegativeSecondaryLabelPressed: colors.redSolid500,
  buttonNegativeSecondaryLabelDisabled: colors.redSolid100,
  buttonNegativeSecondaryBgPressed: colors.redSolid100,
  buttonNegativeSecondaryBgDisabled: colors.redSolid50,
  buttonNegativePrimaryStrokePressed: colors.redSolid600,
  fieldRegularBgDefault: colors.neutralWhiteTransparent0,
  fieldRegularBgHover: colors.neutralWhiteTransparent0,
  fieldRegularBgPressed: colors.neutralWhiteTransparent0,
  fieldRegularBgDisabled: colors.neutralWhiteTransparent0,
  fieldRegularLabelDefault: colors.neutralSolid500,
  fieldRegularLabelHover: colors.neutralSolid500,
  fieldRegularLabelPressed: colors.neutralSolid500,
  fieldRegularLabelFocusTyping: colors.neutralSolid800,
  fieldRegularLabelDisabled: colors.neutralBlackTransparent200,
  fieldRegularIconDefault: colors.neutralSolid500,
  fieldRegularIconHover: colors.neutralSolid500,
  fieldRegularIconPressed: colors.neutralSolid500,
  fieldRegularIconFocusTyping: colors.neutralSolid500,
  fieldRegularIconDisabled: colors.neutralSolid400,
  fieldRegularBgFocusTyping: colors.neutralWhiteTransparent0,
  fieldRegularBgTyped: colors.neutralWhiteTransparent0,
  fieldRegularStrokeDefault: colors.neutralSolid400,
  fieldRegularStrokeHover: colors.primarySolid500,
  fieldRegularStrokePressed: colors.primarySolid500,
  fieldRegularStrokeFocusTyping: colors.primarySolid500,
  fieldRegularStrokeTyped: colors.neutralSolid400,
  fieldRegularStrokeDisabled: colors.neutralSolid300,
  fieldRegularLabelTyped: colors.neutralSolid800,
  fieldRegularIconTyped: colors.neutralSolid500,
  fieldNegativeStrokeDefault: colors.redSolid500,
  fieldNegativeStrokeHover: colors.redSolid600,
  fieldNegativeStrokePressed: colors.redSolid600,
  fieldNegativeStrokeFocusTyping: colors.redSolid500,
  fieldNegativeStrokeTyped: colors.redSolid500,
  chipRegularBgDefault: colors.neutralSolid300,
  chipRegularBgHover: colors.neutralSolid400,
  chipRegularBgPressed: colors.neutralSolid400,
  chipRegularBgFocus: colors.neutralSolid300,
  chipRegularBgDisabled: colors.neutralSolid300,
  chipRegularStrokeFocus: colors.primarySolid500,
  chipRegularLabelDefault: colors.primarySolid900,
  chipRegularLabelHover: colors.primarySolid900,
  chipRegularLabelPressed: colors.primarySolid900,
  chipRegularLabelFocus: colors.primarySolid900,
  chipRegularLabelDisabled: colors.neutralSolid400,
  chipRegularIconDefault: colors.primarySolid900,
  chipRegularIconHover: colors.primarySolid900,
  chipRegularIconPressed: colors.primarySolid900,
  chipRegularIconFocus: colors.primarySolid900,
  chipRegularIconDisabled: colors.neutralSolid400,
  textParagraph: colors.neutralBlackTransparent700,
  textCaption: colors.neutralSolid500,
  textHeadingRegular: colors.neutralSolid900,
  textHeadingHighlighted: colors.neutralSolid1000,
  textLink: colors.primarySolid600,
  textHeadingSubtle: colors.neutralSolid700,
  rowBgDefault: colors.neutralSolid0,
  rowBgHover: colors.neutralSolid200,
  rowBgPressed: colors.neutralSolid200,
  rowBgDisabled: colors.neutralWhiteTransparent0,
  chipSelectedBgDefault: colors.primarySolid50,
  chipSelectedBgHover: colors.primarySolid100,
  chipSelectedBgPressed: colors.primarySolid100,
  chipSelectedBgFocus: colors.primarySolid50,
  chipSelectedBgDisabled: colors.primarySolid50,
  chipSelectedStrokeFocus: colors.primarySolid500,
  chipSelectedLabelDefault: colors.primarySolid900,
  chipSelectedLabelHover: colors.primarySolid900,
  chipSelectedLabelPressed: colors.primarySolid900,
  chipSelectedLabelFocus: colors.primarySolid900,
  chipSelectedLabelDisabled: colors.neutralSolid400,
  chipSelectedIconDefault: colors.neutralSolid700,
  chipSelectedIconHover: colors.neutralSolid700,
  chipSelectedIconPressed: colors.neutralSolid700,
  chipSelectedIconFocus: colors.neutralSolid700,
  chipSelectedIconDisabled: colors.neutralSolid400,
  bgDefault: colors.neutralSolid0,
  progressElipseDefault: colors.neutralSolid200,
  progressLineDefault: colors.primarySolid500,
  progressLabelDefault: colors.neutralSolid1000,
  progressLabelDisabled: colors.neutralSolid400,
  progressLineDisabled: colors.primarySolid200,
  progressElipseDisabled: colors.neutralSolid200,
  buttonHighlightTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonHighlightTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonHighlightQuaternaryBgHover: colors.primarySolid50,
  buttonHighlightQuaternaryBgPressed: colors.primarySolid50,
  buttonHighlightQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonSubtleTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonSubtleTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonSubtleQuaternaryBgHover: colors.neutralWhiteTransparent0,
  buttonSubtleQuaternaryBgPressed: colors.neutralWhiteTransparent0,
  buttonSubtleQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNegativeTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNegativeTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNegativeQuaternaryBgHover: colors.neutralWhiteTransparent0,
  buttonNegativeQuaternaryBgPressed: colors.neutralWhiteTransparent0,
  buttonNegativeQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  chipSelectedStrokeDefault: colors.primarySolid500,
  chipSelectedStrokeHover: colors.primarySolid500,
  chipSelectedStrokePressed: colors.primarySolid500,
  chipSelectedNegativeBgDefault: colors.redSolid50,
  chipSelectedNegativeBgHover: colors.redSolid100,
  chipSelectedNegativeBgPressed: colors.redSolid100,
  chipSelectedNegativeBgFocus: colors.redSolid50,
  chipSelectedNegativeStrokeDefault: colors.redSolid500,
  chipSelectedNegativeStrokeHover: colors.redSolid500,
  chipSelectedNegativeStrokePressed: colors.redSolid500,
  chipSelectedNegativeStrokeFocus: colors.redSolid500,
  chipSelectedNegativeLabelDefault: colors.primarySolid900,
  chipSelectedNegativeLabelHover: colors.primarySolid900,
  chipSelectedNegativeLabelPressed: colors.primarySolid900,
  chipSelectedNegativeLabelFocus: colors.primarySolid900,
  chipSelectedNegativeIconDefault: colors.neutralSolid700,
  chipSelectedNegativeIconHover: colors.neutralSolid700,
  chipSelectedNegativeIconPressed: colors.neutralSolid700,
  chipSelectedNegativeIconFocus: colors.neutralSolid700,
  buttonNeutralPrimaryBgDefault: colors.neutralSolid800,
  buttonNeutralPrimaryBgHover: colors.neutralSolid700,
  buttonNeutralPrimaryBgPressed: colors.neutralSolid700,
  buttonNeutralPrimaryBgDisabled: colors.neutralSolid300,
  buttonNeutralPrimaryIconDefault: colors.neutralSolid0,
  buttonNeutralPrimaryIconPressed: colors.neutralSolid200,
  buttonNeutralPrimaryIconHover: colors.neutralSolid0,
  buttonNeutralPrimaryIconDisabled: colors.neutralSolid0,
  buttonNeutralPrimaryLabelDefault: colors.neutralSolid0,
  buttonNeutralPrimaryLabelHover: colors.neutralSolid0,
  buttonNeutralPrimaryLabelPressed: colors.neutralSolid0,
  buttonNeutralPrimaryLabelDisabled: colors.neutralSolid0,
  buttonNeutralPrimaryStrokePressed: colors.neutralSolid900,
  buttonNeutralSecondaryBgDefault: colors.neutralSolid200,
  buttonNeutralSecondaryBgHover: colors.neutralSolid300,
  buttonNeutralSecondaryBgPressed: colors.neutralSolid300,
  buttonNeutralSecondaryBgDisabled: colors.neutralSolid200,
  buttonNeutralSecondaryIconDefault: colors.neutralSolid600,
  buttonNeutralSecondaryIconPressed: colors.neutralSolid600,
  buttonNeutralSecondaryIconHover: colors.neutralSolid600,
  buttonNeutralSecondaryIconDisabled: colors.neutralSolid400,
  buttonNeutralSecondaryLabelDefault: colors.neutralSolid700,
  buttonNeutralSecondaryLabelHover: colors.neutralSolid700,
  buttonNeutralSecondaryLabelPressed: colors.neutralSolid700,
  buttonNeutralSecondaryLabelDisabled: colors.neutralSolid400,
  buttonNeutralSecondaryStrokePressed: colors.neutralSolid900,
  buttonNeutralTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNeutralTerciaryBgHover: colors.neutralSolid200,
  buttonNeutralTerciaryBgPressed: colors.neutralSolid200,
  buttonNeutralTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNeutralTerciaryIconDefault: colors.neutralSolid700,
  buttonNeutralTerciaryIconPressed: colors.neutralSolid700,
  buttonNeutralTerciaryIconHover: colors.neutralSolid700,
  buttonNeutralTerciaryIconDisabled: colors.neutralSolid400,
  buttonNeutralTerciaryLabelDefault: colors.neutralSolid700,
  buttonNeutralTerciaryLabelHover: colors.neutralSolid700,
  buttonNeutralTerciaryLabelPressed: colors.neutralSolid700,
  buttonNeutralTerciaryLabelDisabled: colors.neutralSolid400,
  buttonNeutralTerciaryStrokeDefault: colors.neutralSolid400,
  buttonNeutralTerciaryStrokeHover: colors.neutralSolid400,
  buttonNeutralTerciaryStrokePressed: colors.neutralSolid1000,
  buttonNeutralTerciaryStrokeDisabled: colors.neutralSolid300,
  buttonNeutralQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNeutralQuaternaryBgHover: colors.neutralSolid200,
  buttonNeutralQuaternaryBgPressed: colors.neutralSolid200,
  buttonNeutralQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNeutralQuaternaryLabelDefault: colors.neutralSolid700,
  buttonNeutralQuaternaryLabelHover: colors.neutralSolid700,
  buttonNeutralQuaternaryLabelPressed: colors.neutralSolid700,
  buttonNeutralQuaternaryLabelDisabled: colors.neutralSolid400,
  buttonNeutralQuaternaryIconDefault: colors.neutralSolid700,
  buttonNeutralQuaternaryIconHover: colors.neutralSolid700,
  buttonNeutralQuaternaryIconPressed: colors.neutralSolid700,
  buttonNeutralQuaternaryIconDisabled: colors.neutralSolid400,
  buttonNeutralQuaternaryStrokePressed: colors.neutralSolid1000,
  shadowPressed: colors.neutralBlackTransparent400,
  blackonwhite: colors.neutralSolid1000,
  whiteonwhite: colors.neutralSolid0,
  tabbaritemUnselected: colors.neutralBlackTransparent500,
  tabbaritemSelected: colors.primarySolid900,
  stroke: colors.neutralSolid300,
  cardBg: colors.neutralSolid200,
  modalShadow: colors.neutralBlackTransparent500,
  modalStroke: colors.neutralSolid700,
  toggleUnselectedBgActive: colors.neutralSolid300,
  toggleSelectedBgActive: colors.greenSolid500,
  toggleUnselectedBgDisabled: colors.neutralSolid200,
  toggleSelectedBgDisabled: colors.greenSolid50,
  toggleUnselectedControlActive: colors.neutralSolid0,
  toggleUnselectedControlDisabled: colors.neutralSolid0,
  toggleSelectedControlActive: colors.neutralSolid0,
  toggleSelectedControlDisabled: colors.neutralSolid0,
  chipSelectedStrokeDisabled: colors.primarySolid200,
  bgDarker: colors.neutralSolid200,
  headerShadow: colors.neutralBlackTransparent50,
  chatbubbleShadow: colors.neutralBlackTransparent50,
  sliderBgActive: colors.neutralSolid300,
  sliderControlActive: colors.primarySolid500,
  sliderControlStrokeUniversal: colors.bgDefault,
  sliderFgActive: colors.primarySolid500,
  sliderBgDisabled: colors.neutralSolid300,
  sliderControlDisabled: colors.primarySolid100,
  sliderFgDisabled: colors.primarySolid100,
  fieldNegativeBgDefault: colors.neutralWhiteTransparent0,
  fieldNegativeBgHover: colors.neutralWhiteTransparent0,
  fieldNegativeBgPressed: colors.neutralWhiteTransparent0,
  fieldNegativeBgFocusTyping: colors.neutralWhiteTransparent0,
  fieldNegativeBgTyped: colors.neutralWhiteTransparent0,
  fieldNegativeLabelDefault: colors.redSolid500,
  fieldNegativeLabelHover: colors.redSolid500,
  fieldNegativeLabelPressed: colors.redSolid500,
  fieldNegativeLabelFocusTyping: colors.neutralSolid800,
  fieldNegativeLabelTyped: colors.neutralSolid800,
  fieldNegativeIconDefault: colors.neutralSolid500,
  fieldNegativeIconHover: colors.neutralSolid500,
  fieldNegativeIconPressed: colors.neutralSolid500,
  fieldNegativeIconFocusTyping: colors.neutralSolid500,
  fieldNegativeIconTyped: colors.neutralSolid500,
  bgDefaultMedium: colors.neutralSolid150,
  bgChat: colors.neutralSolid0,
  bgDefault2: colors.neutralSolid0,
}
